import styled, { css } from 'styled-components';

import { Modal, ModalProps } from 'react-bootstrap';
import { BsPrefixRefForwardingComponent } from 'react-bootstrap/esm/helpers';
import { TypeReport } from './types';

interface ModalCustomProps
  extends BsPrefixRefForwardingComponent<'div', ModalProps> {
  typeReport: TypeReport;
  isMobile: boolean;
}

export const ModalCustom = styled(Modal)<ModalCustomProps>`
  & .modal-dialog {
    max-width: 100vw;
    max-height: 100vh;
    padding: 35px;
    margin: 0;
  }

  & .modal-content {
    & > div {
      height: calc(100vh - 70px);
      overflow: hidden;

      #componenteGrafico {
        min-height: 340px;
      }

      ${({ typeReport, isMobile }) =>
        typeReport === 'graph' &&
        !isMobile &&
        css`
          height: 512px;
        `}
    }
  }

  @media (max-width: 768px) {
    & .modal-dialog {
      padding: 8px;
    }

    & .modal-content {
      & > div {
        width: 100%;
      }
    }
  }
`;

export const Container = styled.div`
  grid-area: consumptionHistory;
  background: #ffffff;
  border-radius: 8px;
  padding: 16px 19px;
`;

export const MessageWrap = styled.div`
  background: #ffffff;
  min-height: 340px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MessageLoading = styled.h1`
  font-size: 2rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;
